async function fetchCart() {
  const res = await fetch('/cart.js', {
    method: 'GET',
    headers: {Accept: 'application/json'},
    credentials: 'same-origin',
  });
  if (!res.ok) throw new Error(`Cart GET ${res.status}`);
  return res.json();
}

async function getCartItems() {
  const cart = await fetchCart();
  checkItemsInCart(cart);
}

document.addEventListener('DOMContentLoaded', function () {
  getCartItems();
});

function checkItemsInCart(cart) {
  const item_count = cart.item_count;
  const total_price = cart.total_price;
  /*
  if (item_count > 0 && total_price == 0) {
    // remove all items from cart

    window.location.href = '/cart/clear'
  }
  */
} // Redirect to homepage if sample product page is visited

(() => {
  if (window.location.host.split('.').at(-2) === 'shopifypreview') return;

  const templateName = document.documentElement.getAttribute('data-product-status');
  if (!templateName.includes('unlisted-free')) return;

  if (document.querySelector('meta[name="robots"]') === null) return;

  window.location.href = '/';
})();
(() => {
  if (window.location.host.split('.').at(-2) !== 'shopifypreview') return;

  const cookieContainer = document.getElementById('onetrust-consent-sdk');
  if (cookieContainer) {
    cookieContainer.style.display = 'none';
    return;
  }

  new MutationObserver((mutations, observer) => {
    const cookieContainer = document.getElementById('onetrust-consent-sdk');
    if (cookieContainer) {
      cookieContainer.style.display = 'none';
      observer.disconnect();
    }
  }).observe(document.body, {childList: true, subtree: true});
})();
(() => {
  const CookieConsentButton = class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }
      if (!this.hasAttribute('aria-haspopup')) {
        this.setAttribute('aria-haspopup', 'dialog');
      }

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.onClick(event);
    };

    onClick = (event) => {
      // Nested inside a <label> for CGV: avoid toggling the checkbox.
      event.preventDefault();
      event.stopPropagation();

      if (window.Optanon?.ToggleInfoDisplay) {
        window.Optanon.ToggleInfoDisplay();
        return;
      }

      this.checkForCookieAPI();
    };

    checkForCookieAPI = () => {
      const maxAttempts = 10;
      const retryInterval = 500;
      let attempts = 0;

      const intervalId = setInterval(() => {
        attempts++;
        if (window.Optanon?.ToggleInfoDisplay) {
          window.Optanon.ToggleInfoDisplay();
          clearInterval(intervalId);
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          console.warn('Cookie Consent API not available.');
        }
      }, retryInterval);
    };
  };
  customElements.define('cookie-consent-button', CookieConsentButton);
})();
